(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.storageKey = this.dataset.storageKey;
      this.dismissible = this.dataset.dismissible === 'true';
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.closeButton = this.querySelector('[data-close]');
      this.marquee = this.querySelector('[data-marquee]');
      this.track = this.querySelector('[data-marquee-track]');
      this.localizationSelects = Array.from(this.querySelectorAll('[data-localization-select]'));

      if (this.dismissible && this.isDismissed()) {
        this.hidden = true;
        this.classList.add('is-dismissed');
        return;
      }

      this.bindEvents();
      this.syncLoopDistance();
    }

    disconnectedCallback() {
      this.unbindEvents();
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }
    }

    bindEvents() {
      this.onClose = () => this.dismiss();
      this.onMouseEnter = () => this.classList.add('is-paused');
      this.onMouseLeave = () => this.classList.remove('is-paused');
      this.onFocusIn = () => this.classList.add('is-paused');
      this.onFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) this.classList.remove('is-paused');
      };
      this.onVisibility = () => {
        this.classList.toggle('is-paused', document.hidden);
      };
      this.onSelectChange = (event) => {
        const form = event.target.closest('form');
        if (form) form.submit();
      };
      this.onResize = () => this.syncLoopDistance();

      this.closeButton?.addEventListener('click', this.onClose);
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.localizationSelects.forEach((select) => {
        select.addEventListener('change', this.onSelectChange);
      });
      window.addEventListener('resize', this.onResize);

      if (typeof ResizeObserver !== 'undefined' && this.marquee) {
        this._resizeObserver = new ResizeObserver(() => this.syncLoopDistance());
        this._resizeObserver.observe(this.marquee);
      }
    }

    unbindEvents() {
      this.closeButton?.removeEventListener('click', this.onClose);
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.removeEventListener('resize', this.onResize);
      this.localizationSelects.forEach((select) => {
        select.removeEventListener('change', this.onSelectChange);
      });
    }

    syncLoopDistance() {
      if (!this.track || this.reduceMotion || this._syncing) return;

      const source = this.track.querySelector('[data-marquee-group]');
      if (!source) return;

      const groupWidth = source.getBoundingClientRect().width;
      if (groupWidth <= 0) return;

      const viewportWidth = (this.marquee || this).getBoundingClientRect().width;

      // The track shifts by exactly one group per cycle, so the remaining
      // groups must still cover the visible area at the end of the loop.
      const needed = Math.max(2, Math.ceil(viewportWidth / groupWidth) + 1);

      this._syncing = true;

      let template = this.track.querySelectorAll('[data-marquee-group]')[1] || source;
      let groups = this.track.querySelectorAll('[data-marquee-group]').length;

      while (groups < needed) {
        const clone = template.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-marquee-clone', '');
        clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
        this.track.appendChild(clone);
        groups += 1;
      }

      while (groups > needed) {
        const last = this.track.lastElementChild;
        if (!last || !last.hasAttribute('data-marquee-clone')) break;
        last.remove();
        groups -= 1;
      }

      this.style.setProperty('--announcement-loop-distance', `${groupWidth}px`);
      this._syncing = false;
    }

    isDismissed() {
      try {
        return sessionStorage.getItem(this.storageKey) === '1';
      } catch (error) {
        return false;
      }
    }

    dismiss() {
      this.classList.add('is-closing');
      const finish = () => {
        this.hidden = true;
        this.classList.add('is-dismissed');
        this.classList.remove('is-closing');
        try {
          sessionStorage.setItem(this.storageKey, '1');
        } catch (error) {
          /* sessionStorage unavailable */
        }
      };

      if (this.reduceMotion) {
        finish();
        return;
      }

      window.setTimeout(finish, 450);
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const bar = event.target.querySelector?.('announcement-bar') || (event.target.matches?.('announcement-bar') ? event.target : null);
    if (bar && typeof bar.syncLoopDistance === 'function') {
      bar.syncLoopDistance();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands"] && !Shopify.designMode) return;
  try {
    
  function initBrandStrips() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-brand-strip]').forEach((root) => {
      const viewport = root.querySelector('[data-brand-viewport]');
      const track = root.querySelector('[data-brand-track]');
      const group = root.querySelector('[data-brand-group]');
      if (!viewport || !track || !group || root.dataset.marqueeReady === 'true') return;

      root.dataset.marqueeReady = 'true';

      while (track.scrollWidth < viewport.offsetWidth * 2 && track.children.length < 12) {
        const clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      const shift = group.getBoundingClientRect().width;
      if (!shift) return;

      const seconds = Number(root.dataset.speed || 32);
      const animation = track.animate(
        [
          { transform: 'translate3d(0, 0, 0)' },
          { transform: 'translate3d(' + -shift + 'px, 0, 0)' },
        ],
        {
          duration: Math.max(12000, seconds * 1000),
          iterations: Infinity,
          easing: 'linear',
        }
      );

      const pause = () => animation.pause();
      const play = () => animation.play();
      viewport.addEventListener('mouseenter', pause);
      viewport.addEventListener('mouseleave', play);
      viewport.addEventListener('touchstart', pause, { passive: true });
      viewport.addEventListener('touchend', play, { passive: true });
    });
  }

  document.addEventListener('DOMContentLoaded', initBrandStrips);
  document.addEventListener('shopify:section:load', initBrandStrips);
  initBrandStrips();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.sectionId = this.dataset.sectionId;
      this.sectionType = this.dataset.sectionType || 'cart-drawer';
      this.rootUrl = this.dataset.rootUrl || '/';
      this.cartChangeUrl = this.dataset.cartChangeUrl;
      this.overlay = this.querySelector('[data-cart-drawer-overlay]');
      this.panel = this.querySelector('[data-cart-drawer-panel]');
      this.bodyEl = this.querySelector('[data-cart-drawer-body]');
      this.openButtons = [];

      this.onOverlayClick = () => this.close();
      this.onKeyDown = (event) => {
        if (event.key === 'Escape' && this.isOpen) this.close();
      };
      this.onBodyClick = (event) => {
        const openTrigger = event.target.closest('[data-cart-drawer-open]');
        if (openTrigger) {
          event.preventDefault();
          this.open();
          return;
        }

        const closeTrigger = event.target.closest('[data-cart-drawer-close]');
        if (closeTrigger && this.contains(closeTrigger)) {
          event.preventDefault();
          this.close();
        }
      };
      this.onQtyClick = (event) => {
        const removeBtn = event.target.closest('[data-qty-remove]');
        const changeBtn = event.target.closest('[data-qty-change]');
        const item = event.target.closest('.cart-drawer__item');
        if (!item) return;

        const input = item.querySelector('[data-qty-input]');
        if (!input) return;

        if (removeBtn) {
          this.updateQuantity(input.dataset.line, 0);
          return;
        }

        if (changeBtn) {
          const next = Number(input.value || 0) + Number(changeBtn.dataset.qtyChange);
          this.updateQuantity(input.dataset.line, Math.max(next, 0));
        }
      };
      this.onQtyChange = (event) => {
        const input = event.target.closest('[data-qty-input]');
        if (!input) return;
        const value = Number(input.value);
        if (Number.isNaN(value)) return;
        this.updateQuantity(input.dataset.line, Math.max(value, 0));
      };
      this.onCartRefresh = async (event) => {
        const shouldOpen = Boolean(event?.detail?.open);
        const sections = event?.detail?.sections;
        const itemCount = event?.detail?.itemCount;

        try {
          if (sections) {
            this.renderSections(sections);
            if (itemCount != null) {
              this.syncBubbles(itemCount);
            } else {
              const countEl = this.querySelector('[data-cart-drawer-count]');
              const match = countEl?.textContent?.match(/\d+/);
              if (match) this.syncBubbles(Number(match[0]));
            }
          } else {
            await this.refresh();
          }
        } catch (error) {
          console.error(error);
        }

        if (shouldOpen) this.open();
      };

      this.overlay?.addEventListener('click', this.onOverlayClick);
      this.addEventListener('click', this.onQtyClick);
      this.addEventListener('change', this.onQtyChange);
      document.addEventListener('keydown', this.onKeyDown);
      document.addEventListener('click', this.onBodyClick);
      document.addEventListener('cart:refresh', this.onCartRefresh);
      document.addEventListener('cart:open', () => this.open());
    }

    disconnectedCallback() {
      this.overlay?.removeEventListener('click', this.onOverlayClick);
      this.removeEventListener('click', this.onQtyClick);
      this.removeEventListener('change', this.onQtyChange);
      document.removeEventListener('keydown', this.onKeyDown);
      document.removeEventListener('click', this.onBodyClick);
      document.removeEventListener('cart:refresh', this.onCartRefresh);
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    open() {
      this.classList.add('is-open');
      document.documentElement.setAttribute('scroll-lock', '');
      this.panel?.focus({ preventScroll: true });
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.removeAttribute('scroll-lock');
    }

    async updateQuantity(line, quantity) {
      this.classList.add('is-loading');

      try {
        const response = await fetch(this.cartChangeUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: Number(line),
            quantity: Number(quantity),
            sections: this.sectionId,
            sections_url: window.location.pathname,
          }),
        });

        if (!response.ok) throw new Error('Cart update failed');

        const data = await response.json();
        this.renderSections(data.sections);
        this.syncBubbles(data.item_count);
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart: data },
          })
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.classList.remove('is-loading');
      }
    }

    async refresh(openAfter = false) {
      this.classList.add('is-loading');
      try {
        const root = this.rootUrl || '/';
        const url = new URL(root, window.location.origin);
        url.searchParams.set('sections', this.sectionId);

        const response = await fetch(url.toString(), {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Cart refresh failed');

        const sections = await response.json();
        this.renderSections(sections);

        const countEl = this.querySelector('[data-cart-drawer-count]');
        const match = countEl?.textContent?.match(/\d+/);
        if (match) this.syncBubbles(Number(match[0]));

        if (openAfter) this.open();
      } catch (error) {
        console.error(error);
      } finally {
        this.classList.remove('is-loading');
      }
    }

    renderSections(sections) {
      if (!sections) return;
      const html = sections[this.sectionId] || sections[this.sectionType];
      if (!html) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const incoming = doc.querySelector('cart-drawer') || doc.getElementById('CartDrawer') || doc.body.firstElementChild;
      if (!incoming) return;

      const nextBody = incoming.querySelector('[data-cart-drawer-body]');
      const nextFooter = incoming.querySelector('.cart-drawer__footer');
      const nextCount = incoming.querySelector('[data-cart-drawer-count]');
      const currentFooter = this.querySelector('.cart-drawer__footer');
      const currentCount = this.querySelector('[data-cart-drawer-count]');

      if (nextBody) {
        if (this.bodyEl) this.bodyEl.replaceWith(nextBody);
        else this.panel?.insertBefore(nextBody, currentFooter || null);
        this.bodyEl = this.querySelector('[data-cart-drawer-body]');
      }

      if (nextCount && currentCount) currentCount.replaceWith(nextCount);

      if (nextFooter) {
        if (currentFooter) currentFooter.replaceWith(nextFooter);
        else this.panel?.appendChild(nextFooter);
      } else if (currentFooter) {
        currentFooter.remove();
      }
    }

    syncBubbles(count) {
      const value = Number(count) || 0;
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = String(value);
        el.classList.toggle('is-hidden', value === 0);
        el.setAttribute('aria-hidden', value === 0 ? 'true' : 'false');
      });
      document.querySelectorAll('[data-cart-count-live]').forEach((el) => {
        el.textContent = value === 1 ? '1 item' : `${value} items`;
      });
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const bindSort = (root = document) => {
      root.querySelectorAll('[data-collection-sort]').forEach((select) => {
        if (select.dataset.bound === 'true') return;
        select.dataset.bound = 'true';
        select.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', select.value);
          url.searchParams.delete('page');
          window.location.assign(url.toString());
        });
      });
    };

    bindSort();
    document.addEventListener('shopify:section:load', (event) => bindSort(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-videos"] && !Shopify.designMode) return;
  try {
    
  class CustomerReviewsScroll extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = this.dataset.autoplay === 'true';

      if (!autoplay || reduceMotion) {
        this.classList.add('is-paused');
      }

      this.track = this.querySelector('[data-track]');
      this.syncLoopDistance = () => {
        const group = this.track?.querySelector('[data-review-group], .customer-reviews__list');
        if (!this.track || !group) return;
        const distance = group.getBoundingClientRect().width;
        if (distance > 0) {
          this.track.style.setProperty('--cr-loop-distance', `${distance}px`);
        }
      };

      this.onResize = () => {
        window.clearTimeout(this._resizeTimer);
        this._resizeTimer = window.setTimeout(() => this.syncLoopDistance(), 120);
      };

      this.syncLoopDistance();
      requestAnimationFrame(() => this.syncLoopDistance());
      window.addEventListener('resize', this.onResize, { passive: true });

      this.onOpen = (event) => {
        const trigger = event.target.closest('[data-open-media]');
        if (!trigger || !this.contains(trigger)) return;
        event.preventDefault();
        const dialogId = trigger.getAttribute('data-dialog-id');
        if (!dialogId) return;
        const dialog = this.querySelector(`#${CSS.escape(dialogId)}`);
        if (!dialog) return;
        this.openDialog(dialog);
      };

      this.onClose = (event) => {
        const closeBtn = event.target.closest('[data-close-dialog]');
        if (!closeBtn) return;
        const dialog = closeBtn.closest('dialog');
        if (dialog) this.closeDialog(dialog);
      };

      this.onDialogClick = (event) => {
        const dialog = event.target;
        if (!(dialog instanceof HTMLDialogElement)) return;
        if (event.target === dialog) this.closeDialog(dialog);
      };

      this.addEventListener('click', this.onOpen);
      this.addEventListener('click', this.onClose);
      this.querySelectorAll('dialog').forEach((dialog) => {
        dialog.addEventListener('click', this.onDialogClick);
        dialog.addEventListener('close', () => this.resetDialogMedia(dialog));
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      window.clearTimeout(this._resizeTimer);
      this._ready = false;
    }

    openDialog(dialog) {
      this.classList.add('is-paused');
      dialog.showModal();
      const iframe = dialog.querySelector('[data-external-iframe]');
      if (iframe) {
        const src = iframe.dataset.embedSrc;
        if (src) {
          const join = src.includes('?') ? '&' : '?';
          iframe.src = `${src}${join}autoplay=1`;
        }
      }
      const video = dialog.querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.play().catch(() => {});
      }
    }

    closeDialog(dialog) {
      dialog.close();
      if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.remove('is-paused');
      }
    }

    resetDialogMedia(dialog) {
      const iframe = dialog.querySelector('[data-external-iframe]');
      if (iframe) iframe.src = '';
      const video = dialog.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }
  }

  if (!customElements.get('customer-reviews-scroll')) {
    customElements.define('customer-reviews-scroll', CustomerReviewsScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  class CustomerReviewsScroll extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = this.dataset.autoplay === 'true';

      if (!autoplay || reduceMotion) {
        this.classList.add('is-paused');
      }

      this.track = this.querySelector('[data-track]');
      this.syncLoopDistance = () => {
        const group = this.track?.querySelector('[data-review-group], .customer-reviews__list');
        if (!this.track || !group) return;
        const distance = group.getBoundingClientRect().width;
        if (distance > 0) {
          this.track.style.setProperty('--cr-loop-distance', `${distance}px`);
        }
      };

      this.onResize = () => {
        window.clearTimeout(this._resizeTimer);
        this._resizeTimer = window.setTimeout(() => this.syncLoopDistance(), 120);
      };

      this.syncLoopDistance();
      requestAnimationFrame(() => this.syncLoopDistance());
      window.addEventListener('resize', this.onResize, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      window.clearTimeout(this._resizeTimer);
      this._ready = false;
    }
  }

  if (!customElements.get('customer-reviews-scroll')) {
    customElements.define('customer-reviews-scroll', CustomerReviewsScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-testimonials"] && !Shopify.designMode) return;
  try {
    
  class CustomerTestimonialsScroll extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = this.dataset.autoplay === 'true';

      if (!autoplay || reduceMotion) {
        this.classList.add('is-paused');
      }

      this.track = this.querySelector('[data-track]');
      this.syncLoopDistance = () => {
        const group = this.track?.querySelector('[data-testimonial-group], .customer-testimonials__list');
        if (!this.track || !group) return;
        const distance = group.getBoundingClientRect().width;
        if (distance > 0) {
          this.track.style.setProperty('--ct-loop-distance', `${distance}px`);
        }
      };

      this.onResize = () => {
        window.clearTimeout(this._resizeTimer);
        this._resizeTimer = window.setTimeout(() => this.syncLoopDistance(), 120);
      };

      this.syncLoopDistance();
      requestAnimationFrame(() => this.syncLoopDistance());
      window.addEventListener('resize', this.onResize, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      window.clearTimeout(this._resizeTimer);
      this._ready = false;
    }
  }

  if (!customElements.get('customer-testimonials-scroll')) {
    customElements.define('customer-testimonials-scroll', CustomerTestimonialsScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-footer-top]').forEach((button) => {
    if (button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';
    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderMenu extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.sticky = this.dataset.sticky === 'true';
      this.transparent = this.dataset.transparent === 'true';
      this.drawer = this.querySelector('[data-header-drawer]');
      this.search = this.querySelector('[data-header-search]');
      this.menuOpenBtn = this.querySelector('[data-mobile-menu-open]');
      this.mouseX = -1;
      this.mouseY = -1;
      this.pointerActive = false;

      this.isDesktopNav = () =>
        window.matchMedia('(min-width: 990px)').matches &&
        window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      this.getDropdownItems = () => [
        ...this.querySelectorAll('.site-header__nav-item.has-dropdown'),
      ];

      this.setDropdownOpenState = (item, open) => {
        item.classList.toggle('is-open', open);
        item.querySelector('[data-submenu-trigger]')?.setAttribute('aria-expanded', String(open));
        const menu = item.querySelector('[data-submenu]');
        if (!menu) return;
        if (open) {
          menu.hidden = false;
          menu.removeAttribute('inert');
          menu.setAttribute('aria-hidden', 'false');
        } else {
          menu.hidden = true;
          menu.setAttribute('inert', '');
          menu.setAttribute('aria-hidden', 'true');
        }
      };

      this.closeAllDropdowns = () => {
        this.getDropdownItems().forEach((item) => this.setDropdownOpenState(item, false));
      };

      this.openDropdown = (item) => {
        this.getDropdownItems().forEach((other) => {
          this.setDropdownOpenState(other, other === item);
        });
      };

      /**
       * Source of truth: only show a dropdown when the live pointer is over
       * that item's nav link or its open panel. Never open from scroll alone.
       */
      this.syncDropdownFromPointer = () => {
        if (!this.isDesktopNav() || !this.pointerActive) {
          this.closeAllDropdowns();
          return;
        }

        const under = document.elementFromPoint(this.mouseX, this.mouseY);
        if (!under || !this.contains(under)) {
          this.closeAllDropdowns();
          return;
        }

        const item = under.closest('.site-header__nav-item.has-dropdown');
        if (!item || !this.contains(item)) {
          this.closeAllDropdowns();
          return;
        }

        const onTrigger = Boolean(under.closest('[data-submenu-trigger]'));
        const alreadyOpen = item.classList.contains('is-open');

        /* Open only from the nav link; keep open while pointer stays in that item/panel */
        if (onTrigger) {
          this.openDropdown(item);
          return;
        }
        if (alreadyOpen && item.contains(under)) {
          return;
        }

        this.closeAllDropdowns();
      };

      this.onMouseMove = (event) => {
        this.mouseX = event.clientX;
        this.mouseY = event.clientY;
        this.pointerActive = true;
        this.syncDropdownFromPointer();
      };

      this.onScroll = () => {
        this.handleScroll();
        /* Scrolling must never leave menus open, even if cursor later sits over header */
        this.pointerActive = false;
        this.closeAllDropdowns();
      };

      this.onMenuOpen = () => this.drawer?.open?.();
      this.onUtilityClick = (event) => {
        const searchBtn = event.target.closest('[data-search-open]');
        const wishlistBtn = event.target.closest('[data-wishlist-open]');
        if (!searchBtn && !wishlistBtn) return;
        if (this.drawer?.isOpen) this.drawer.close();
        if (searchBtn) this.search?.open?.();
      };

      this.onTriggerClick = (event) => {
        const trigger = event.target.closest('[data-submenu-trigger]');
        if (!trigger) return;
        if (this.isDesktopNav()) return;
        const item = trigger.closest('.site-header__nav-item');
        if (!item || !item.classList.contains('has-dropdown')) return;
        event.preventDefault();
        const willOpen = !item.classList.contains('is-open');
        this.closeAllDropdowns();
        if (willOpen) this.openDropdown(item);
      };

      /* Safety: ignore clicks on closed dropdown links (ghost hit targets) */
      this.onGhostDropdownClick = (event) => {
        const link = event.target.closest('.site-header__dropdown a');
        if (!link || !this.contains(link)) return;
        const item = link.closest('.site-header__nav-item.has-dropdown');
        if (item?.classList.contains('is-open')) return;
        event.preventDefault();
        event.stopPropagation();
      };

      this.onPreviewEnter = (event) => {
        const link = event.target.closest('[data-dropdown-preview]');
        if (!link) return;
        const panel = link.closest('[data-dropdown-panel]');
        if (!panel) return;
        const index = link.getAttribute('data-dropdown-preview');
        panel.querySelectorAll('[data-preview-item]').forEach((item) => {
          const active = item.getAttribute('data-preview-item') === index;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) item.removeAttribute('tabindex');
          else item.setAttribute('tabindex', '-1');
        });
      };

      this.onDocumentClick = (event) => {
        if (!this.isDesktopNav()) return;
        if (event.target.closest('.site-header__nav-item.has-dropdown')) return;
        this.closeAllDropdowns();
      };

      this.menuOpenBtn?.addEventListener('click', this.onMenuOpen);
      this.addEventListener('click', this.onUtilityClick);
      this.addEventListener('click', this.onTriggerClick);
      this.addEventListener('click', this.onGhostDropdownClick, true);
      this.addEventListener('mouseover', this.onPreviewEnter);
      document.addEventListener('mousemove', this.onMouseMove, { passive: true });
      document.addEventListener('click', this.onDocumentClick);
      window.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
      this.closeAllDropdowns();
      this.handleScroll();
    }

    disconnectedCallback() {
      this.menuOpenBtn?.removeEventListener('click', this.onMenuOpen);
      this.removeEventListener('click', this.onUtilityClick);
      this.removeEventListener('click', this.onTriggerClick);
      this.removeEventListener('click', this.onGhostDropdownClick, true);
      this.removeEventListener('mouseover', this.onPreviewEnter);
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('click', this.onDocumentClick);
      window.removeEventListener('scroll', this.onScroll, { capture: true });
      this._ready = false;
    }

    handleScroll() {
      const scrolled = window.scrollY > 12;
      this.classList.toggle('is-scrolled', scrolled);
      if (this.transparent) this.classList.toggle('is-solid', scrolled);
    }
  }

  class HeaderDrawer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.panel = this.querySelector('[data-drawer-panel]');
      this.overlay = this.querySelector('[data-drawer-overlay]');
      this.closeBtn = this.querySelector('[data-mobile-menu-close]');
      this.onClose = () => this.close();
      this.onKey = (event) => {
        if (event.key === 'Escape' && this.isOpen) this.close();
      };
      this.overlay?.addEventListener('click', this.onClose);
      this.closeBtn?.addEventListener('click', this.onClose);
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      this.overlay?.removeEventListener('click', this.onClose);
      this.closeBtn?.removeEventListener('click', this.onClose);
      document.removeEventListener('keydown', this.onKey);
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    open() {
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.documentElement.setAttribute('scroll-lock', '');
      this.panel?.focus({ preventScroll: true });
      document.querySelector('[data-mobile-menu-open]')?.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.removeAttribute('scroll-lock');
      document.querySelector('[data-mobile-menu-open]')?.setAttribute('aria-expanded', 'false');
      window.setTimeout(() => {
        if (!this.isOpen) this.hidden = true;
      }, 420);
    }
  }

  class HeaderSearch extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.panel = this.querySelector('[data-search-panel]');
      this.overlay = this.querySelector('[data-search-overlay]');
      this.closeBtn = this.querySelector('[data-search-close]');
      this.input = this.querySelector('[data-predictive-search-input]');
      this.onClose = () => this.close();
      this.onKey = (event) => {
        if (event.key === 'Escape' && this.isOpen) this.close();
      };
      this.overlay?.addEventListener('click', this.onClose);
      this.closeBtn?.addEventListener('click', this.onClose);
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      this.overlay?.removeEventListener('click', this.onClose);
      this.closeBtn?.removeEventListener('click', this.onClose);
      document.removeEventListener('keydown', this.onKey);
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    open() {
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.documentElement.setAttribute('scroll-lock', '');
      document.querySelectorAll('[data-search-open]').forEach((btn) => {
        btn.setAttribute('aria-expanded', 'true');
      });
      window.setTimeout(() => this.input?.focus(), 80);
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.removeAttribute('scroll-lock');
      document.querySelectorAll('[data-search-open]').forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
      });
      window.setTimeout(() => {
        if (!this.isOpen) this.hidden = true;
      }, 420);
    }
  }

  if (!customElements.get('tah-header-menu')) customElements.define('tah-header-menu', HeaderMenu);
  if (!customElements.get('header-drawer')) customElements.define('header-drawer', HeaderDrawer);
  if (!customElements.get('header-search')) customElements.define('header-search', HeaderSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const instances = new WeakMap();

    class HeroBannersController {
      constructor(root) {
        this.root = root;
        this.banners = Array.from(root.querySelectorAll('[data-banner]'));
        this.tabs = Array.from(root.querySelectorAll('[data-tab]'));
        this.prevButton = root.querySelector('[data-prev]');
        this.nextButton = root.querySelector('[data-next]');
        this.autoplay = root.dataset.autoplay === 'true';
        this.autoplaySpeed = Number(root.dataset.autoplaySpeed) || 6000;
        this.index = Math.max(
          0,
          this.banners.findIndex((banner) => banner.classList.contains('is-active'))
        );
        this.timer = null;
        this.isPaused = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.banners.length < 1) return;

        this.bindEvents();
        this.setActive(this.index, false);
        this.startAutoplay();
      }

      destroy() {
        this.unbindEvents();
        this.stopAutoplay();
      }

      bindEvents() {
        this.onPrev = () => this.prev();
        this.onNext = () => this.next();
        this.onMouseEnter = () => this.pause();
        this.onMouseLeave = () => this.resume();
        this.onFocusIn = () => this.pause();
        this.onFocusOut = (event) => {
          if (!this.root.contains(event.relatedTarget)) this.resume();
        };
        this.onVisibility = () => {
          if (document.hidden) this.pause();
          else this.resume();
        };
        this.onKeyDown = (event) => {
          if (this.banners.length < 2) return;
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.prev();
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.next();
          }
        };
        this.onTabClick = (event) => {
          const nextIndex = Number(event.currentTarget.dataset.index);
          if (Number.isNaN(nextIndex)) return;
          this.setActive(nextIndex);
          this.restartAutoplay();
        };

        this.prevButton?.addEventListener('click', this.onPrev);
        this.nextButton?.addEventListener('click', this.onNext);
        this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick));
        this.root.addEventListener('mouseenter', this.onMouseEnter);
        this.root.addEventListener('mouseleave', this.onMouseLeave);
        this.root.addEventListener('focusin', this.onFocusIn);
        this.root.addEventListener('focusout', this.onFocusOut);
        this.root.addEventListener('keydown', this.onKeyDown);
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      unbindEvents() {
        this.prevButton?.removeEventListener('click', this.onPrev);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.tabs.forEach((tab) => tab.removeEventListener('click', this.onTabClick));
        this.root.removeEventListener('mouseenter', this.onMouseEnter);
        this.root.removeEventListener('mouseleave', this.onMouseLeave);
        this.root.removeEventListener('focusin', this.onFocusIn);
        this.root.removeEventListener('focusout', this.onFocusOut);
        this.root.removeEventListener('keydown', this.onKeyDown);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      prev() {
        this.setActive((this.index - 1 + this.banners.length) % this.banners.length);
        this.restartAutoplay();
      }

      next() {
        this.setActive((this.index + 1) % this.banners.length);
        this.restartAutoplay();
      }

      setActive(index, animateProgress = true) {
        this.index = index;

        this.banners.forEach((banner, i) => {
          const isActive = i === index;
          banner.classList.toggle('is-active', isActive);
          banner.setAttribute('aria-hidden', String(!isActive));
        });

        this.tabs.forEach((tab, i) => {
          const isActive = i === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          const bar = tab.querySelector('[data-progress]');
          if (!bar) return;
          bar.classList.remove('is-running');
          bar.style.animationDuration = '';
          void bar.offsetWidth;
          if (isActive && animateProgress && this.autoplay && !this.reduceMotion && !this.isPaused) {
            bar.style.animationDuration = `${this.autoplaySpeed}ms`;
            bar.classList.add('is-running');
          }
        });
      }

      startAutoplay() {
        if (!this.autoplay || this.reduceMotion || this.banners.length < 2 || this.isPaused) return;
        this.stopAutoplay();
        this.timer = window.setInterval(() => this.next(), this.autoplaySpeed);
        const bar = this.tabs[this.index]?.querySelector('[data-progress]');
        if (bar) {
          bar.classList.remove('is-running');
          bar.style.animationDuration = `${this.autoplaySpeed}ms`;
          void bar.offsetWidth;
          bar.classList.add('is-running');
        }
      }

      stopAutoplay() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      pause() {
        this.isPaused = true;
        this.stopAutoplay();
        this.tabs.forEach((tab) => {
          const bar = tab.querySelector('[data-progress]');
          if (bar) bar.classList.remove('is-running');
        });
      }

      resume() {
        this.isPaused = false;
        this.startAutoplay();
      }
    }

    function mount(root) {
      if (!(root instanceof HTMLElement)) return;
      const existing = instances.get(root);
      if (existing) existing.destroy();
      instances.set(root, new HeroBannersController(root));
    }

    function initAll(scope) {
      const roots = (scope || document).querySelectorAll('[data-hero-banners]');
      roots.forEach((root) => mount(root));
    }

    function onSectionLoad(event) {
      const section = event.target;
      if (!(section instanceof HTMLElement)) return;
      const root = section.matches('[data-hero-banners]')
        ? section
        : section.querySelector('[data-hero-banners]');
      if (root) mount(root);
    }

    function onSectionUnload(event) {
      const section = event.target;
      if (!(section instanceof HTMLElement)) return;
      const root = section.matches('[data-hero-banners]')
        ? section
        : section.querySelector('[data-hero-banners]');
      const existing = root && instances.get(root);
      if (existing) {
        existing.destroy();
        instances.delete(root);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    document.addEventListener('shopify:section:reorder', () => initAll());
    document.addEventListener('shopify:block:select', onSectionLoad);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals"] && !Shopify.designMode) return;
  try {
    
  class NewArrivalsScroll extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay === 'true';
      this.track = this.querySelector('[data-track]');
      this.viewport = this.querySelector('.new-arrivals__viewport');

      if (!this.autoplay || this.reduceMotion) {
        this.classList.add('is-paused');
      }

      this.onMouseEnter = () => this.classList.add('is-paused');
      this.onMouseLeave = () => {
        if (this.autoplay && !this.reduceMotion) this.classList.remove('is-paused');
      };
      this.onFocusIn = () => this.classList.add('is-paused');
      this.onFocusOut = (event) => {
        if (!this.contains(event.relatedTarget) && this.autoplay && !this.reduceMotion) {
          this.classList.remove('is-paused');
        }
      };
      this.onVisibility = () => {
        if (document.hidden) {
          this.classList.add('is-paused');
        } else if (this.autoplay && !this.reduceMotion) {
          this.classList.remove('is-paused');
        }
      };
      this.onResize = () => {
        window.clearTimeout(this._resizeTimer);
        this._resizeTimer = window.setTimeout(() => this.syncLoopDistance(), 120);
      };

      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('visibilitychange', this.onVisibility);
      window.addEventListener('resize', this.onResize, { passive: true });

      if (typeof ResizeObserver !== 'undefined' && this.viewport) {
        this._resizeObserver = new ResizeObserver(() => this.syncLoopDistance());
        this._resizeObserver.observe(this.viewport);
      }

      this.syncLoopDistance();
      requestAnimationFrame(() => this.syncLoopDistance());

      // Re-measure after product images settle so card widths are final.
      this.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', () => this.syncLoopDistance(), { once: true });
      });
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.removeEventListener('resize', this.onResize);
      window.clearTimeout(this._resizeTimer);
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }
    }

    syncLoopDistance() {
      if (!this.track || this.reduceMotion || this._syncing) return;

      const source = this.track.querySelector('[data-na-group]');
      if (!source) return;

      const styles = window.getComputedStyle(this.track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const groupWidth = source.getBoundingClientRect().width;
      if (groupWidth <= 0) return;

      const loopDistance = groupWidth + gap;
      const viewportWidth = (this.viewport || this).getBoundingClientRect().width;
      const needed = Math.max(2, Math.ceil(viewportWidth / loopDistance) + 1);

      this._syncing = true;

      let groups = this.track.querySelectorAll('[data-na-group]').length;
      const template = this.track.querySelectorAll('[data-na-group]')[1] || source;

      while (groups < needed) {
        const clone = template.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('role', 'presentation');
        clone.setAttribute('data-na-clone', '');
        clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        this.track.appendChild(clone);
        groups += 1;
      }

      while (groups > needed) {
        const last = this.track.lastElementChild;
        if (!last || !last.hasAttribute('data-na-clone')) break;
        last.remove();
        groups -= 1;
      }

      this.track.style.setProperty('--na-loop-distance', `${loopDistance}px`);
      this._syncing = false;
    }
  }

  if (!customElements.get('new-arrivals-scroll')) {
    customElements.define('new-arrivals-scroll', NewArrivalsScroll);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const scroller =
      event.target.querySelector?.('new-arrivals-scroll') ||
      (event.target.matches?.('new-arrivals-scroll') ? event.target : null);
    if (scroller && typeof scroller.syncLoopDistance === 'function') {
      scroller.syncLoopDistance();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class TahProductPage extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.addLabel = this.dataset.addLabel || 'Add to cart';
      this.soldOutLabel = this.dataset.soldOutLabel || 'Sold out';
      this.cartAddUrl = this.dataset.cartAddUrl;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';

      this.form = this.querySelector('[data-product-form]');
      this.variantInput = this.querySelector('[data-variant-input]');
      this.atcBtn = this.querySelector('[data-add-to-cart]');
      this.atcLabel = this.querySelector('[data-atc-label]');
      this.buyBtn = this.querySelector('[data-buy-now]');
      this.priceEl = this.querySelector('[data-price]');
      this.compareEl = this.querySelector('[data-compare]');
      this.discountEl = this.querySelector('[data-discount]');
      this.saveEl = this.querySelector('[data-save]');
      this.saleBadge = this.querySelector('[data-sale-badge]');
      this.availability = this.querySelector('[data-availability]');
      this.availabilityText = this.querySelector('[data-availability-text]');
      this.mainImage = this.querySelector('[data-main-image]');
      this.optionsRoot = this.querySelector('[data-options]');
      this.qtyInput = this.querySelector('[data-qty-input]');
      this.gallery = this.querySelector('[data-gallery]');
      this.thumbs = this.querySelector('[data-thumbs]');
      this.actionsAnchor = this.querySelector('[data-actions-anchor]');
      this.stickyBar = this.querySelector('[data-sticky-bar]');
      this.stickyAtc = this.querySelector('[data-sticky-atc]');
      this.stickyAtcLabel = this.querySelector('[data-sticky-atc-label]');
      this.stickyBuy = this.querySelector('[data-sticky-buy]');
      this.stickyPrice = this.querySelector('[data-sticky-price]');
      this.stickyCompare = this.querySelector('[data-sticky-compare]');
      this.stage = this.querySelector('[data-stage]');
      this.lightbox = this.querySelector('[data-lightbox]');
      this.lightboxImage = this.querySelector('[data-lightbox-image]');
      this.lightboxCount = this.querySelector('[data-lightbox-count]');

      try {
        this.galleryImages = JSON.parse(this.querySelector('[data-gallery-json]')?.textContent || '[]');
      } catch (e) {
        this.galleryImages = [];
      }
      this.lightboxIndex = 0;

      try {
        this.product = JSON.parse(this.querySelector('[data-product-json]')?.textContent || '{}');
      } catch (e) {
        this.product = { variants: [], options: [] };
      }

      const currentId = Number(this.variantInput?.value);
      const current = this.product.variants?.find((v) => v.id === currentId) || this.product.variants?.[0];
      this.selectedOptions = [
        current?.option1 || null,
        current?.option2 || null,
        current?.option3 || null,
      ].slice(0, (this.product.options || []).length);

      this.onOptionClick = (event) => {
        const button = event.target.closest('[data-option-value]');
        if (!button || !this.optionsRoot?.contains(button)) return;
        const fieldset = button.closest('[data-option-index]');
        const index = Number(fieldset?.dataset.optionIndex);
        if (Number.isNaN(index)) return;
        this.selectedOptions[index] = button.dataset.optionValue;
        const label = fieldset.querySelector('[data-selected-label]');
        if (label) label.textContent = button.dataset.optionValue;
        this.renderOptions();
        this.syncVariant();
      };

      this.onGalleryClick = (event) => {
        const thumb = event.target.closest('[data-thumb]');
        if (!thumb || !this.gallery?.contains(thumb)) return;
        event.preventDefault();
        this.selectThumb(thumb);
      };

      this.onSubmit = (event) => {
        event.preventDefault();
        this.addToCart(false);
      };

      this.onBuyNow = () => this.addToCart(true);
      this.onStickyAtc = () => this.addToCart(false);
      this.onStickyBuy = () => this.addToCart(true);
      this.onQtyMinus = () => this.setQty(-1);
      this.onQtyPlus = () => this.setQty(1);
      this.onMediaPrev = () => this.stepMedia(-1);
      this.onMediaNext = () => this.stepMedia(1);
      this.onStageClick = (event) => {
        if (event.target.closest('[data-media-prev], [data-media-next], [data-thumb]')) return;
        if (this.stage?.classList.contains('is-video')) return;
        if (!event.target.closest('[data-zoom], [data-main-image]')) return;
        this.openLightbox();
      };
      this.onLightboxClick = (event) => {
        if (event.target.closest('[data-lightbox-close]')) {
          this.closeLightbox();
          return;
        }
        if (event.target.closest('[data-lightbox-prev]')) {
          this.stepLightbox(-1);
          return;
        }
        if (event.target.closest('[data-lightbox-next]')) {
          this.stepLightbox(1);
        }
      };
      this.onLightboxKey = (event) => {
        if (this.lightbox?.hidden) return;
        if (event.key === 'Escape') this.closeLightbox();
        if (event.key === 'ArrowLeft') this.stepLightbox(-1);
        if (event.key === 'ArrowRight') this.stepLightbox(1);
      };
      this.onLightboxTouchStart = (event) => {
        this._lbStartX = event.changedTouches?.[0]?.clientX || 0;
      };
      this.onLightboxTouchEnd = (event) => {
        if (this.lightbox?.hidden) return;
        const endX = event.changedTouches?.[0]?.clientX || 0;
        const delta = endX - (this._lbStartX || 0);
        if (Math.abs(delta) < 50) return;
        this.stepLightbox(delta < 0 ? 1 : -1);
      };

      this.optionsRoot?.addEventListener('click', this.onOptionClick);
      this.gallery?.addEventListener('click', this.onGalleryClick);
      this.form?.addEventListener('submit', this.onSubmit);
      this.buyBtn?.addEventListener('click', this.onBuyNow);
      this.stickyAtc?.addEventListener('click', this.onStickyAtc);
      this.stickyBuy?.addEventListener('click', this.onStickyBuy);
      this.querySelector('[data-qty-minus]')?.addEventListener('click', this.onQtyMinus);
      this.querySelector('[data-qty-plus]')?.addEventListener('click', this.onQtyPlus);
      this.querySelector('[data-media-prev]')?.addEventListener('click', this.onMediaPrev);
      this.querySelector('[data-media-next]')?.addEventListener('click', this.onMediaNext);
      this.stage?.addEventListener('click', this.onStageClick);
      this.lightbox?.addEventListener('click', this.onLightboxClick);
      this.lightbox?.addEventListener('touchstart', this.onLightboxTouchStart, { passive: true });
      this.lightbox?.addEventListener('touchend', this.onLightboxTouchEnd, { passive: true });
      document.addEventListener('keydown', this.onLightboxKey);

      this.setupSwipe();
      this.setupStickyBar();

      if (this.dataset.hasVariants === 'true') {
        this.renderOptions();
        this.syncVariant();
      }
    }

    disconnectedCallback() {
      this.optionsRoot?.removeEventListener('click', this.onOptionClick);
      this.gallery?.removeEventListener('click', this.onGalleryClick);
      this.form?.removeEventListener('submit', this.onSubmit);
      this.buyBtn?.removeEventListener('click', this.onBuyNow);
      this.stickyAtc?.removeEventListener('click', this.onStickyAtc);
      this.stickyBuy?.removeEventListener('click', this.onStickyBuy);
      this.querySelector('[data-qty-minus]')?.removeEventListener('click', this.onQtyMinus);
      this.querySelector('[data-qty-plus]')?.removeEventListener('click', this.onQtyPlus);
      this.querySelector('[data-media-prev]')?.removeEventListener('click', this.onMediaPrev);
      this.querySelector('[data-media-next]')?.removeEventListener('click', this.onMediaNext);
      this.stage?.removeEventListener('click', this.onStageClick);
      this.lightbox?.removeEventListener('click', this.onLightboxClick);
      this.lightbox?.removeEventListener('touchstart', this.onLightboxTouchStart);
      this.lightbox?.removeEventListener('touchend', this.onLightboxTouchEnd);
      document.removeEventListener('keydown', this.onLightboxKey);
      document.body.classList.remove('is-lightbox-open');
      this.stickyObserver?.disconnect();
      if (this.stage && this._onTouchStart) {
        this.stage.removeEventListener('touchstart', this._onTouchStart);
        this.stage.removeEventListener('touchend', this._onTouchEnd);
      }
    }

    openLightbox() {
      if (!this.lightbox || !this.galleryImages.length) return;
      const activeId = this.querySelector('[data-thumb].is-active')?.getAttribute('data-media-id');
      let index = this.galleryImages.findIndex((item) => String(item.id) === String(activeId));
      if (index < 0) index = 0;
      this.lightboxIndex = index;
      this.renderLightbox();
      this.lightbox.hidden = false;
      document.body.classList.add('is-lightbox-open');
      this.lightbox.querySelector('[data-lightbox-dialog]')?.focus();
    }

    closeLightbox() {
      if (!this.lightbox) return;
      this.lightbox.hidden = true;
      document.body.classList.remove('is-lightbox-open');
    }

    stepLightbox(step) {
      if (!this.galleryImages.length) return;
      const total = this.galleryImages.length;
      this.lightboxIndex = (this.lightboxIndex + step + total) % total;
      this.renderLightbox();
    }

    renderLightbox() {
      const item = this.galleryImages[this.lightboxIndex];
      if (!item || !this.lightboxImage) return;
      this.lightboxImage.src = item.src;
      this.lightboxImage.alt = item.alt || '';
      if (this.lightboxCount) {
        const template = this.lightbox?.dataset.countTemplate || '__INDEX__ / __COUNT__';
        this.lightboxCount.textContent = template
          .replace('__INDEX__', String(this.lightboxIndex + 1))
          .replace('__COUNT__', String(this.galleryImages.length));
      }
      const many = this.galleryImages.length > 1;
      this.querySelector('[data-lightbox-prev]')?.toggleAttribute('hidden', !many);
      this.querySelector('[data-lightbox-next]')?.toggleAttribute('hidden', !many);
    }

    selectThumb(thumb) {
      if (!thumb) return;
      this.setActiveThumb(thumb);
      this.showMedia(thumb.getAttribute('data-media-id'), thumb.getAttribute('data-media-type'));
      thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    stepMedia(step) {
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      if (!thumbs.length) return;
      const activeIndex = thumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
      const current = activeIndex < 0 ? 0 : activeIndex;
      const nextIndex = (current + step + thumbs.length) % thumbs.length;
      this.selectThumb(thumbs[nextIndex]);
    }

    showMedia(mediaId, mediaType) {
      if (!mediaId) return;
      const host = this.querySelector('[data-media-host]');
      const template = this.querySelector(`[data-media-template="${mediaId}"]`);
      if (!host || !template) return;

      this.pauseActiveMedia();
      host.classList.remove('is-loaded');
      host.removeAttribute('data-skeleton-ready');
      delete host.dataset.skeletonBound;
      host.setAttribute('data-skeleton', '');
      host.replaceChildren(template.content.cloneNode(true));

      const type = mediaType || template.getAttribute('data-media-type') || 'image';
      this.stage?.classList.toggle('is-video', type === 'video' || type === 'external_video');
      this.mainImage = this.querySelector('[data-main-image]');

      const video = host.querySelector('video');
      if (video) {
        video.muted = true;
        video.setAttribute('playsinline', '');
        const playPromise = video.play?.();
        if (playPromise?.catch) playPromise.catch(() => {});
      }

      if (window.TahReveal?.initSkeletons) {
        window.TahReveal.initSkeletons(host.parentElement || this);
      }
    }

    pauseActiveMedia() {
      this.querySelectorAll('[data-media-host] video').forEach((video) => {
        try {
          video.pause();
          video.currentTime = 0;
        } catch (e) {}
      });
    }

    setupSwipe() {
      if (!this.stage) return;
      let startX = 0;
      this._onTouchStart = (e) => {
        startX = e.changedTouches?.[0]?.clientX || 0;
      };
      this._onTouchEnd = (e) => {
        const endX = e.changedTouches?.[0]?.clientX || 0;
        const delta = endX - startX;
        if (Math.abs(delta) < 40) return;
        this.stepMedia(delta < 0 ? 1 : -1);
      };
      this.stage.addEventListener('touchstart', this._onTouchStart, { passive: true });
      this.stage.addEventListener('touchend', this._onTouchEnd, { passive: true });
    }

    setupStickyBar() {
      if (!this.stickyBar || !this.actionsAnchor || !('IntersectionObserver' in window)) return;
      if (window.matchMedia('(min-width: 750px)').matches) return;

      this.stickyObserver = new IntersectionObserver(
        ([entry]) => {
          const show = !entry.isIntersecting;
          this.stickyBar.classList.toggle('is-visible', show);
          this.stickyBar.hidden = !show;
        },
        { threshold: 0, rootMargin: '0px 0px -8px 0px' }
      );
      this.stickyObserver.observe(this.actionsAnchor);
    }

    setQty(delta) {
      if (!this.qtyInput) return;
      this.qtyInput.value = String(Math.max(1, Number(this.qtyInput.value || 1) + delta));
    }

    findVariant(options) {
      return (this.product.variants || []).find((variant) =>
        options.every((value, index) => !value || variant[`option${index + 1}`] === value)
      );
    }

    isValueSoldOut(optionIndex, value) {
      const probe = [...this.selectedOptions];
      probe[optionIndex] = value;
      const matches = (this.product.variants || []).filter((variant) =>
        probe.every((selected, index) => !selected || variant[`option${index + 1}`] === selected)
      );
      return !matches.length || matches.every((variant) => !variant.available);
    }

    renderOptions() {
      this.optionsRoot?.querySelectorAll('[data-option-index]').forEach((fieldset) => {
        const index = Number(fieldset.dataset.optionIndex);
        const selected = this.selectedOptions[index] || '';
        fieldset.querySelectorAll('[data-option-value]').forEach((button) => {
          const value = button.dataset.optionValue;
          button.classList.toggle('is-selected', value === selected);
          button.classList.toggle('is-soldout', this.isValueSoldOut(index, value));
          button.setAttribute('aria-pressed', String(value === selected));
        });
      });
    }

    syncVariant() {
      const variant = this.findVariant(this.selectedOptions);
      if (!variant) {
        if (this.variantInput) this.variantInput.value = '';
        this.setPurchaseState(false);
        return;
      }

      if (this.variantInput) this.variantInput.value = String(variant.id);
      const formattedPrice = this.formatMoney(variant.price);
      if (this.priceEl) this.priceEl.textContent = formattedPrice;
      if (this.stickyPrice) this.stickyPrice.textContent = formattedPrice;

      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (this.compareEl) {
        this.compareEl.hidden = !onSale;
        if (onSale) this.compareEl.textContent = this.formatMoney(variant.compare_at_price);
      }
      if (this.stickyCompare) {
        this.stickyCompare.hidden = !onSale;
        if (onSale) this.stickyCompare.textContent = this.formatMoney(variant.compare_at_price);
      }

      if (this.discountEl) {
        if (onSale && variant.price > 0) {
          const percent = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          this.discountEl.hidden = false;
          this.discountEl.textContent = `${percent}% OFF`;
          if (this.saleBadge) {
            this.saleBadge.hidden = false;
            this.saleBadge.textContent = `${percent}% OFF`;
          }
        } else {
          this.discountEl.hidden = true;
          if (this.saleBadge) this.saleBadge.hidden = true;
        }
      }

      if (this.saveEl) {
        if (onSale) {
          this.saveEl.hidden = false;
          this.saveEl.textContent = `Save ${this.formatMoney(variant.compare_at_price - variant.price)}`;
        } else {
          this.saveEl.hidden = true;
        }
      }

      if (variant.featured_media_id) {
        const thumb = this.querySelector(`[data-thumb][data-media-id="${variant.featured_media_id}"]`);
        if (thumb) {
          this.selectThumb(thumb);
        } else {
          this.showMedia(String(variant.featured_media_id));
        }
      }

      this.setPurchaseState(variant.available);
    }

    setPurchaseState(available) {
      const label = available ? this.addLabel : this.soldOutLabel;
      const buttons = [this.atcBtn, this.buyBtn, this.stickyAtc, this.stickyBuy];
      buttons.forEach((btn) => {
        if (!btn) return;
        if (available) btn.removeAttribute('disabled');
        else btn.setAttribute('disabled', '');
      });
      if (this.atcLabel) this.atcLabel.textContent = label;
      if (this.stickyAtcLabel) this.stickyAtcLabel.textContent = label;
      if (this.availability) this.availability.classList.toggle('is-out', !available);
      if (this.availabilityText) this.availabilityText.textContent = available ? 'In stock' : this.soldOutLabel;
    }

    setActiveThumb(active) {
      this.querySelectorAll('[data-thumb]').forEach((thumb) => {
        const on = thumb === active;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-pressed', String(on));
      });
    }

    setMainImage(src, alt, srcset, sizes) {
      if (!src) return;
      if (!this.mainImage) {
        this.mainImage = this.querySelector('[data-main-image]');
      }
      if (!this.mainImage) return;

      this.mainImage.style.opacity = '0.4';
      this.mainImage.setAttribute('src', src);
      this.mainImage.src = src;

      if (srcset) {
        this.mainImage.setAttribute('srcset', srcset);
        this.mainImage.srcset = srcset;
      } else {
        this.mainImage.removeAttribute('srcset');
      }

      if (sizes) {
        this.mainImage.setAttribute('sizes', sizes);
        this.mainImage.sizes = sizes;
      } else {
        this.mainImage.setAttribute('sizes', '(min-width: 990px) 52vw, 100vw');
      }

      if (alt) this.mainImage.alt = alt;

      const reveal = () => {
        this.mainImage.style.opacity = '1';
      };

      if (this.mainImage.complete) {
        requestAnimationFrame(reveal);
      } else {
        this.mainImage.addEventListener('load', reveal, { once: true });
        this.mainImage.addEventListener('error', reveal, { once: true });
      }
    }

    async addToCart(checkout) {
      if (!this.atcBtn || this.atcBtn.disabled || !this.cartAddUrl) return;
      const id = Number(this.variantInput?.value);
      const quantity = Math.max(1, Number(this.qtyInput?.value || 1));
      if (!id) return;

      const cartDrawer = document.querySelector('cart-drawer');
      const sectionId = cartDrawer?.dataset.sectionId;
      [this.atcBtn, this.buyBtn, this.stickyAtc, this.stickyBuy].forEach((btn) => btn?.classList.add('is-loading'));

      try {
        const payload = { items: [{ id, quantity }] };
        if (sectionId && !checkout) {
          payload.sections = sectionId;
          payload.sections_url = window.location.pathname;
        }
        const response = await fetch(this.cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Add to cart failed');
        if (checkout) {
          window.location.href = '/checkout';
          return;
        }
        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            detail: { open: true, sections: data.sections, itemCount: data.item_count, cart: data },
          })
        );
      } catch (error) {
        console.error(error);
      } finally {
        [this.atcBtn, this.buyBtn, this.stickyAtc, this.stickyBuy].forEach((btn) => btn?.classList.remove('is-loading'));
      }
    }

    formatMoney(cents) {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, this.moneyFormat);
      const amount = (Number(cents) / 100).toFixed(2);
      return this.moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }
  }

  if (!customElements.get('tah-product-page')) {
    customElements.define('tah-product-page', TahProductPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  class RelatedProducts extends HTMLElement {
    connectedCallback() {
      if (this.dataset.useManual === 'true') return;
      if (this.dataset.loaded === 'true') return;

      this.content = this.querySelector('[data-related-content]');
      if (!this.content) return;

      const url = this.dataset.url;
      if (!url) return;

      const load = () => {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';

        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error('Recommendations request failed');
            return response.text();
          })
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const fetched = doc.querySelector('[data-related-content]');
            if (!fetched) return;

            const hasProducts = fetched.querySelector('.related-products__item');
            if (!hasProducts) {
              // No live recommendations: keep the first-paint fallback grid.
              return;
            }

            // Assign innerHTML from a string so the injected <product-card>
            // custom elements are reliably upgraded and their click handlers run.
            this.content.innerHTML = fetched.innerHTML;
            this.classList.remove('is-empty');
            if (window.TahReveal?.boot) {
              window.TahReveal.boot(this);
            }
          })
          .catch(() => {
            this.dataset.loaded = 'false';
          });
      };

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.unobserve(this);
            load();
          },
          { rootMargin: '200px 0px' }
        );
        this._observer.observe(this);
      } else {
        load();
      }
    }

    disconnectedCallback() {
      this._observer?.disconnect();
    }
  }

  if (!customElements.get('related-products')) {
    customElements.define('related-products', RelatedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (() => {
    const bindSort = (root = document) => {
      root.querySelectorAll('[data-search-sort]').forEach((select) => {
        if (select.dataset.bound === 'true') return;
        select.dataset.bound = 'true';
        select.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', select.value);
          url.searchParams.delete('page');
          window.location.assign(url.toString());
        });
      });
    };

    bindSort();
    document.addEventListener('shopify:section:load', (event) => bindSort(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
